import $ from 'jquery';

const SELECTOR = '.hero-slider';

function onDocumentReady() {
	$(SELECTOR).each(initializeElement);
}

function initializeElement(i, el) {
	const $el = $(el);
	const cards = $el.children();

	if (cards.length < 2) {
		return;
	}

	cards.each((i, t) => {
		const text = `${i + 1}/${cards.length}`;
		const tNum = $(`<div class="card-number">${text}</div>`);

		$(t).find('.card-content').append(tNum);
	});

	$el.slick({
		autoplay: true,
		autoplaySpeed: 8000,
	});
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
